// Mock data for Casa de Repouso São Jorge - Sistema de Estoque e Consumo
// This data is MOCKED and stored in localStorage on the frontend for now.

export const empresa = {
  nome: "Residencial São Jorge",
  cnpj: "35.778.613/0001-39",
  email: "contato@casaderepousosaojorge.com.br",
  site: "http://casaderepousosaojorge.com.br/",
  endereco: "Rua São Miguel Arcanjo, nº 148 - Quinta da Paineira",
  cep: "03.152-050 - São Paulo/SP",
  telefone: "(11) 3564-5553",
  telefone2: "(11) 96462-5452",
};

// Credenciais de acesso (mock)
export const authCredentials = {
  email: "contato@casaderepousosaojorge.com.br",
  senha: "123ganhei",
  usuario: {
    nome: "Administrador",
    cargo: "Gestor",
    email: "contato@casaderepousosaojorge.com.br",
  },
};

// Catálogo de produtos (precoVenda = valor cobrado na fatura quando sai do estoque da empresa)
export const produtos = [
  { id: "p1", nome: "Fralda Geriátrica G", categoria: "Higiene", unidade: "un", precoVenda: 2.5, estoqueMinimo: 100 },
  { id: "p2", nome: "Fralda Geriátrica M", categoria: "Higiene", unidade: "un", precoVenda: 2.3, estoqueMinimo: 100 },
  { id: "p3", nome: "Lenço Umedecido (pacote)", categoria: "Higiene", unidade: "pct", precoVenda: 8.9, estoqueMinimo: 20 },
  { id: "p4", nome: "Sabonete Líquido", categoria: "Higiene", unidade: "un", precoVenda: 12.5, estoqueMinimo: 15 },
  { id: "p5", nome: "Pomada para Assadura", categoria: "Higiene", unidade: "un", precoVenda: 18.0, estoqueMinimo: 10 },
  { id: "p6", nome: "Creme Hidratante", categoria: "Higiene", unidade: "un", precoVenda: 22.0, estoqueMinimo: 10 },
  { id: "p7", nome: "Dipirona 500mg", categoria: "Medicamento", unidade: "comp", precoVenda: 0.4, estoqueMinimo: 200 },
  { id: "p8", nome: "Losartana 50mg", categoria: "Medicamento", unidade: "comp", precoVenda: 0.6, estoqueMinimo: 200 },
  { id: "p9", nome: "Soro Fisiológico 500ml", categoria: "Medicamento", unidade: "un", precoVenda: 6.0, estoqueMinimo: 30 },
  { id: "p10", nome: "Luva Descartável (par)", categoria: "Descartável", unidade: "par", precoVenda: 0.5, estoqueMinimo: 300 },
  { id: "p11", nome: "Papel Higiênico (rolo)", categoria: "Higiene", unidade: "rolo", precoVenda: 1.2, estoqueMinimo: 80 },
  { id: "p12", nome: "Shampoo", categoria: "Higiene", unidade: "un", precoVenda: 15.0, estoqueMinimo: 10 },
];

// Residentes
export const residentes = [
  { id: "r1", nome: "Maria das Dores Silva", quarto: "101", dataInternacao: "2024-01-15", status: "Ativo", responsavel: "Ana Silva", telefone: "(11) 98888-1010" },
  { id: "r2", nome: "João Batista Oliveira", quarto: "102", dataInternacao: "2023-11-02", status: "Ativo", responsavel: "Pedro Oliveira", telefone: "(11) 98888-2020" },
  { id: "r3", nome: "Antônia Ferreira Lima", quarto: "103", dataInternacao: "2024-03-20", status: "Ativo", responsavel: "Clara Lima", telefone: "(11) 98888-3030" },
  { id: "r4", nome: "José Carlos Souza", quarto: "104", dataInternacao: "2024-05-10", status: "Ativo", responsavel: "Marcos Souza", telefone: "(11) 98888-4040" },
  { id: "r5", nome: "Terezinha Gomes", quarto: "105", dataInternacao: "2023-08-25", status: "Ativo", responsavel: "Rita Gomes", telefone: "(11) 98888-5050" },
  { id: "r6", nome: "Sebastião Alves", quarto: "106", dataInternacao: "2024-06-01", status: "Ativo", responsavel: "Luiz Alves", telefone: "(11) 98888-6060" },
];

// Estoque da empresa: { produtoId: quantidade }
export const estoqueEmpresa = {
  p1: 420, p2: 380, p3: 45, p4: 22, p5: 8, p6: 14,
  p7: 520, p8: 340, p9: 40, p10: 800, p11: 60, p12: 6,
};

// Estoque de cada residente (fornecimento familiar): { residenteId: { produtoId: qty } }
export const estoqueResidente = {
  r1: { p1: 60, p3: 4, p5: 2 },
  r2: { p2: 40, p8: 90 },
  r3: { p1: 20 },
  r4: {},
  r5: { p2: 30, p3: 3, p6: 1 },
  r6: { p1: 10 },
};

// Histórico de fornecimentos familiares (entradas no estoque do residente)
export const fornecimentos = [
  { id: "f1", residenteId: "r1", produtoId: "p1", quantidade: 60, data: "2025-07-01", entreguePor: "Ana Silva" },
  { id: "f2", residenteId: "r1", produtoId: "p3", quantidade: 4, data: "2025-07-01", entreguePor: "Ana Silva" },
  { id: "f3", residenteId: "r2", produtoId: "p2", quantidade: 40, data: "2025-07-02", entreguePor: "Pedro Oliveira" },
  { id: "f4", residenteId: "r5", produtoId: "p2", quantidade: 30, data: "2025-07-03", entreguePor: "Rita Gomes" },
];

// Histórico de consumos (internação). qtdResidente sai do fornecimento familiar; qtdEmpresa é cobrado.
export const consumos = [
  { id: "c1", residenteId: "r1", produtoId: "p1", quantidade: 4, qtdResidente: 4, qtdEmpresa: 0, valorCobrado: 0, data: "2025-07-05" },
  { id: "c2", residenteId: "r4", produtoId: "p1", quantidade: 5, qtdResidente: 0, qtdEmpresa: 5, valorCobrado: 12.5, data: "2025-07-05" },
  { id: "c3", residenteId: "r3", produtoId: "p1", quantidade: 6, qtdResidente: 6, qtdEmpresa: 0, valorCobrado: 0, data: "2025-07-06" },
  { id: "c4", residenteId: "r2", produtoId: "p8", quantidade: 2, qtdResidente: 2, qtdEmpresa: 0, valorCobrado: 0, data: "2025-07-06" },
  { id: "c5", residenteId: "r4", produtoId: "p7", quantidade: 3, qtdResidente: 0, qtdEmpresa: 3, valorCobrado: 1.2, data: "2025-07-07" },
  { id: "c6", residenteId: "r6", produtoId: "p1", quantidade: 12, qtdResidente: 10, qtdEmpresa: 2, valorCobrado: 5.0, data: "2025-07-07" },
];

// Status de faturas pagas: { "residenteId_YYYY-MM": true }
// Helpers de data dinâmica (para os dados de exemplo ficarem sempre no mês atual)
const _hoje = new Date();
const _d = (offsetDias) => {
  const dt = new Date(_hoje);
  dt.setDate(dt.getDate() - offsetDias);
  return dt.toISOString().slice(0, 10);
};

// Ajusta datas dos mocks para o período corrente
fornecimentos.forEach((f, i) => { f.data = _d(20 - i * 2); });
consumos.forEach((c, i) => { c.data = _d(6 - i); });

export const faturasPagas = {};

export const SEED = {
  produtos,
  residentes,
  estoqueEmpresa,
  estoqueResidente,
  fornecimentos,
  consumos,
  faturasPagas,
};
